import Layout from "../../../../src/components/Octopath/layout";
import Enemy from "../../../../src/components/Octopath/Enemy";
import React from 'react';
export default {
  Layout,
  Enemy,
  React
};